import { RouteRecordRaw } from "vue-router";
import { HOME_URL } from "@/config";
import Layout from "@/layouts/index.vue";

/**
 * LayoutRouter (布局路由)
 */
export const layoutRouter: RouteRecordRaw[] = [
  {
    path: HOME_URL, // 路由访问路径[唯一]
    name: "layout", // 命名路由[唯一]
    component: Layout, // 这个页面是整个布局
    redirect: "/index",
    children: [],
  },
  {
    path: "/index",
    name: "Index",
    component: import("@/views/index/index.vue"),
  },
];

/**
 * StaticRouter (静态路由)
 */
export const staticRouter: RouteRecordRaw[] = [
  {
    path: "/cloudArchive",
    name: "cloudArchive",
    component: () => import("@/views/cloudArchive/index.vue"),
  },
  {
    path: "/cloudArchive2/:tab?",
    name: "cloudArchive2",
    component: () => import("@/views/cloudArchive/index.vue"),
  },
  {
    path: "/landMap",
    name: "landMapIndex",
    component: () => import("@/views/landMap/index.vue"),
  },
  {
    path: "/map",
    name: "mapIndex",
    component: () => import("@/views/map/index.vue"),
  },
  {
    path: "/testmap",
    name: "textMapIndex",
    component: () => import("@/webviewNative/test/map.vue"),
  },
  {
    path: "/cloudQuery",
    name: "cloudQuery",
    component: () => import("@/views/cloudQuery/add.vue"),
  },
  {
    path: "/cloudQueryInfo",
    name: "cloudQueryInfo",
    component: () => import("@/views/cloudQuery/baseInfo.vue"),
  },
  {
    path: "/cloudQueryReport",
    name: "cloudQueryReport",
    component: () => import("@/views/cloudQuery/QueryReport.vue"),
  },
  {
    path: "/inspectionDetails",
    name: "inspectionDetails",
    component: () => import("@/views/cloudArchive/inspection/details.vue"),
  },
  {
    path: "/login",
    name: "loginIndex",
    component: () => import("@/views/login/index.vue"),
  },
];

/**
 * errorRouter (错误页面路由)
 */
export const errorRouter = [
  {
    path: "/403",
    name: "403",
    component: () => import("@/views/error/403.vue"),
    meta: {
      title: "403页面",
      icon: "QuestionFilled", // 菜单图标
      isHide: "1", // 代表路由在菜单中是否隐藏，是否隐藏[0隐藏，1显示]
      isLink: "1", // 是否外链[有值则是外链]
      isKeepAlive: "0", // 是否缓存路由数据[0是，1否]
      isFull: "1", // 是否缓存全屏[0是，1否]
      isAffix: "1", // 是否缓存固定路由[0是，1否]
    },
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/error/404.vue"),
    meta: {
      title: "404页面",
      icon: "CircleCloseFilled", // 菜单图标
      isHide: "1", // 代表路由在菜单中是否隐藏，是否隐藏[0隐藏，1显示]
      isLink: "1", // 是否外链[有值则是外链]
      isKeepAlive: "0", // 是否缓存路由数据[0是，1否]
      isFull: "1", // 是否缓存全屏[0是，1否]
      isAffix: "1", // 是否缓存固定路由[0是，1否]
    },
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/error/500.vue"),
    meta: {
      title: "500页面",
      icon: "WarningFilled", // 图标
      isHide: "1", // 代表路由在菜单中是否隐藏，是否隐藏[0隐藏，1显示]
      isLink: "1", // 是否外链[有值则是外链]
      isKeepAlive: "0", // 是否缓存路由数据[0是，1否]
      isFull: "1", // 是否缓存全屏[0是，1否]
      isAffix: "1", // 是否缓存固定路由[0是，1否]
    },
  },
  // 找不到path将跳转404页面
  {
    path: "/:pathMatch(.*)*",
    component: () => import("@/views/error/404.vue"),
  },
];
